module.exports = __webpack_public_path__ + "media/images/admin/icons/octagon-a6ea5fa517cbb4566808b7399744101f.svg";